import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GeoPosition } from '../../types/GeoPosition';

interface ReaderState {
  targetLocation?: GeoPosition | null;
  isShowAllReaders: boolean;
  isShowGeofences: boolean;
  isShowFacilities: boolean;
}

const initialState: ReaderState = {
  targetLocation: null,
  isShowAllReaders: true,
  isShowGeofences: false,
  isShowFacilities: false,
};

export const mapSlice = createSlice({
  name: 'maps',
  initialState,
  reducers: {
    updateTargetLocationState: (state, action: PayloadAction<GeoPosition | null>) => {
      state.targetLocation = action.payload;
    },
  },
});

export const { updateTargetLocationState } = mapSlice.actions;
export default mapSlice.reducer;
